// src/pages/geral/leads/LeadCaptacaoConsultaPage.js
import React, { useState } from 'react';
import { FaEye, FaSearch } from 'react-icons/fa';
import PageContainer from '../../../components/geral/PageContainer';
import PageHeader from '../../../components/geral/PageHeader';
import PageContent from '../../../components/geral/PageContent';
import PageFooter from '../../../components/geral/PageFooter';
import Input from '../../../components/input/Input';
import Select from '../../../components/input/Select';
import { useConfigModulo } from '../../../contexts/administrativo/ConfigModuloContext';
import { LeadCaptacaoProvider, useLeadCaptacao } from '../../../contexts/geral/LeadCaptacaoContext';
import { formatarDataLead, intencoesLead, textoLead } from '../../../models/geral/LeadCaptacao';
import LeadCaptacaoDetalhesModal from './LeadCaptacaoDetalhesModal';
import './LeadCaptacaoConsultaPage.css';

const ConsultaLeads = () => {
  const { resultado, carregando, erro, buscar, mudarPagina, mudarTamanhoPagina, abrirDetalhes } = useLeadCaptacao();
  const [busca, setBusca] = useState('');
  const [intencao, setIntencao] = useState('');
  const totalPaginas = Math.max(1, Math.ceil(resultado.total / resultado.tamanhoPagina));

  const pesquisar = event => {
    event.preventDefault();
    if (!carregando) buscar({ busca, intencao });
  };

  return (
    <PageContainer className="leads-consulta-page">
      <h2 className="page-title">Consulta de Leads</h2>
      <PageHeader>
        <form className="leads-consulta-filtros" onSubmit={pesquisar}>
          <Input label="Busca" placeholder="Nome, telefone ou município" type="search" size={300}
            maxLength={100} value={busca} onChange={event => setBusca(event.target.value)} />
          <Select label="Intenção" size={170} value={intencao}
            options={[{ value: '', label: 'Todas' }, ...intencoesLead]}
            onChange={event => setIntencao(event.target.value)} />
          <button type="submit" className="btn btn-search" disabled={carregando}>
            <FaSearch aria-hidden="true" /> Buscar
          </button>
          <Select label="Por página" size={110} value={resultado.tamanhoPagina} disabled={carregando}
            options={[10, 20, 50].map(valor => ({ value: valor, label: String(valor) }))}
            onChange={event => mudarTamanhoPagina(Number(event.target.value))} />
        </form>
      </PageHeader>
      <PageContent>
        <table className="page-content-table leads-consulta-table" aria-label="Leads captados" aria-busy={carregando}>
          <thead>
            <tr>
              <th scope="col">ID</th><th scope="col">Cadastro</th><th scope="col">Nome</th>
              <th scope="col">Telefone</th><th scope="col">Município/UF</th><th scope="col">Ramo</th>
              <th scope="col" className="leads-consulta-qualificacao">Segmentos de alimentação</th>
              <th scope="col" className="leads-consulta-qualificacao">Formas de atendimento</th>
              <th scope="col" className="leads-consulta-qualificacao">Principais desafios</th>
              <th scope="col">Tipo de empresa</th><th scope="col">Dispositivos</th>
              <th scope="col">Intenção</th><th scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            {carregando ? (
              <tr><td colSpan={13}><span role="status">Carregando leads...</span></td></tr>
            ) : erro ? (
              <tr><td colSpan={13}><span role="alert">{erro}</span></td></tr>
            ) : resultado.itens.length === 0 ? (
              <tr><td colSpan={13}>Nenhum lead encontrado.</td></tr>
            ) : resultado.itens.map(lead => (
              <tr key={lead.id}>
                <td>{lead.id}</td><td>{formatarDataLead(lead.dataCadastro)}</td>
                <td>{textoLead(lead.nomeCompleto)}</td><td>{textoLead(lead.telefone)}</td>
                <td>{lead.localidade}</td><td>{lead.ramoDescricao}</td>
                <td>{lead.segmentosAlimentacaoDescricao}</td><td>{lead.formasAtendimentoDescricao}</td>
                <td>{lead.principaisDesafiosDescricao}</td><td>{lead.tipoDescricao}</td>
                <td>{lead.dispositivosDescricao}</td><td>{lead.intencaoDescricao}</td>
                <td>
                  <button type="button" className="btn btn-outline-secondary btn-sm"
                    aria-label={`Detalhes de ${lead.nomeCompleto}`} onClick={() => abrirDetalhes(lead.id)}>
                    <FaEye aria-hidden="true" /> Detalhes
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </PageContent>
      <PageFooter>
        <div className="leads-consulta-paginacao">
          <span>{erro ? 'Consulta indisponível' : `${resultado.total} registro(s)`}</span>
          <nav aria-label="Paginação dos leads" className="leads-consulta-paginas">
            <button type="button" className="btn btn-sm btn-outline-secondary"
              disabled={carregando || !!erro || resultado.pagina <= 1} onClick={() => mudarPagina(resultado.pagina - 1)}>Anterior</button>
            <span aria-live="polite">{!erro && `Página ${resultado.pagina} de ${totalPaginas}`}</span>
            <button type="button" className="btn btn-sm btn-outline-secondary"
              disabled={carregando || !!erro || resultado.pagina >= totalPaginas} onClick={() => mudarPagina(resultado.pagina + 1)}>Próxima</button>
          </nav>
        </div>
      </PageFooter>
      <LeadCaptacaoDetalhesModal />
    </PageContainer>
  );
};

const LeadCaptacaoConsultaPage = () => {
  const { configModuloSel } = useConfigModulo();
  if (!configModuloSel?.mensalidade) {
    return (
      <PageContainer>
        <h2 className="page-title">Consulta de Leads</h2>
        <p role="status" className="alert alert-info mt-3">A consulta de leads está indisponível para este módulo.</p>
      </PageContainer>
    );
  }
  return <LeadCaptacaoProvider><ConsultaLeads /></LeadCaptacaoProvider>;
};

export default LeadCaptacaoConsultaPage;
